/// Leaves the site to pay in Mercado Pago (VEN-7). Its own module so a test can stand in for the
/// browser, which cannot navigate away under jsdom.
export function goToCheckout(url: string): void {
  window.location.assign(url);
}
